import React from 'react'

const CARDS = [
  {
    img: '/images/why-education.jpeg',
    alt: 'Education and football in schools',
    title: 'Education and Football Grow Stronger Together',
    text: 'By embedding football development within schools, SISDI ensures children do not have to choose between their education and their passion. This balanced approach keeps learners in school while using football to reinforce discipline, focus, and academic commitment.',
  },
  {
    img: '/images/why-access.jpeg',
    alt: 'Securing children\'s futures',
    title: "Securing Children's Futures Beyond the Game",
    text: 'SISDI sensitizes and equips young players with education, life skills, trainings, and guidance to succeed in different career paths, even beyond football, reducing the risk of lost potential and social vulnerability.',
  },
  {
    img: '/images/why-community.jpeg',
    alt: 'Equal access for every child',
    title: 'Equal Access to Opportunity for Every Child',
    text: 'School-based programs make football and education accessible regardless of gender or economic background. SISDI creates safe, inclusive spaces where both boys and girls can learn, play, and grow — especially in communities where such opportunities are rare.',
  },
]

export default function WhyItMatters() {
  return (
    <section className="section bg-light fade-in">
      <div className="container">
        <div className="section-header">
          <span className="eyebrow">Our Mission</span>
          <h2>Why <span className="text-accent">This Matters</span></h2>
          <div className="section-divider"></div>
          <p style={{ maxWidth: '620px', margin: '1.5rem auto 0' }}>
            Across Africa, millions of children grow up with talent, ambition, and
            dreams — but without the systems and resources needed to nurture them
            safely and holistically.
          </p>
        </div>

        <div className="grid-3 fade-in-stagger">
          {CARDS.map((c, i) => (
            <div className="why-card" key={i}>
              <img src={c.img} alt={c.alt} className="why-card-img" />
              <div className="why-card-body">
                <h4>{c.title}</h4>
                <p>{c.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
